import {FeatureFlags} from '@medad-sep/core';

import {ENV_CONFIG, DEFAULT_FEATBIT_CONFIG} from './constants';

const configOverride = ENV_CONFIG ?? DEFAULT_FEATBIT_CONFIG;

const featBitConfig =
  (configOverride.featBitConfig as typeof DEFAULT_FEATBIT_CONFIG.featBitConfig) || DEFAULT_FEATBIT_CONFIG.featBitConfig;

export const buildFeatBitOptions = (featureFlags?: FeatureFlags) => {
  if (featureFlags?.enabled && featureFlags?.sdkKey) {
    return {
      sdkKey: featureFlags.sdkKey,
      streamingUri: featureFlags.streamingUri || featBitConfig.streamingUri || '',
      eventsUrl: featureFlags.eventsUrl || featBitConfig.eventsUrl || '',
      pollingUri: featureFlags.pollingUri || featBitConfig.pollingUri || '',
      user: DEFAULT_FEATBIT_CONFIG.user,
    };
  }

  return undefined;
};
